import { render } from "./CardSlider.vue?vue&type=template&id=5c849dcc&scoped=true"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"

import "./CardSlider.vue?vue&type=style&index=0&id=5c849dcc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c849dcc"]])

export default __exports__